export const DOC_TYPES = {
	uploadable: 'upload',
	signable: 'signature',
	irs: 'irs',
	tax_identification_number: 'tax_identification_number',
	letter_of_authorization: 'letter_of_authorization',
	miscellaneous: 'miscellaneous',
};

export const DOC_DOCUMENT_TYPES = {
	dealers_license: 'Documents::DealersLicense',
	drivers_license: 'Documents::DriversLicense',
	power_of_attorney: 'Documents::PowerOfAttorney',
	owners_drivers_license: 'Documents::OwnersDriversLicense',
	articles_of_incorporation: 'articles_of_incorporation',
	irs: 'irs',
};

export const DOC_COMPLIANCE_FIELD_KEYS = {
	tax_identification_number: 'tax_identification_number',
	letter_of_authorization: 'letter_of_authorization',
};

export const DOC_STATUSES = {
	pending: 'pending',
	uploaded: 'uploaded',
	signed: 'signed',
};

export const W9_STATUSES = {
	pendingVerification: 'pending_verification',
	verified: 'verified',
	verificationFailed: 'verification_failed',
};

export const AVALARA_W9_STATUSES = Object.values(W9_STATUSES);

export const DOC_BUSINESS_TYPES = {
	franchise: 'Franchise dealer',
	independent: 'Independent dealer',
	wholesaler: 'Wholesaler',
};

export const DOC_SIGNATURE_EVENT = {
	sign: 'sign',
};

const ONE_MB_TO_BYTES = 1048576;

export const MAX_UPLOAD_SIZE_MB = 10;

export const MAX_UPLOAD_SIZE_BYTES = MAX_UPLOAD_SIZE_MB * ONE_MB_TO_BYTES;
